
import { SHOW_MODAL, HIDE_MODAL} from "../actions/ModalActions"

const initialState = {
  isOpen: false,
  modalType:null,
  data:{},
  api:"",
  message:'Perform next!'
};

const modalReducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_MODAL:
      return { ...state, isOpen: true, modalType: action.payload.modalType, data:action.payload.data, api:action.payload.api, message:action.payload.message};
    case HIDE_MODAL:
      return { ...state, isOpen: false, modalType:null, data:{}, api:"", message:"Perform Next!" };
    default:
      return state;
  }
};

export default modalReducer;